
import * as React from "react";
import { Button } from "./ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";
import { FaRegFilePdf, FaRegCopy } from "react-icons/fa";
import { BsArrowReturnLeft } from "react-icons/bs";
import { useMessageActions } from "../hooks/useMessageActions";
import { ChatMessage } from "../../types/discuss.types";
import { cn } from "@/lib/utils";

interface DiscussBulkActionsProps {
    messages: ChatMessage[];
    documentId?: string;
    documentTitle?: string;
    className?: string;
}

const DiscussBulkActions: React.FC<DiscussBulkActionsProps> = ({
    messages,
    documentId,
    documentTitle,
    className,
}) => {
    const {
        handleCopyMessage,
        handleInsertMessageToDocument,
        handleCreateDocumentFromMessage,
    } = useMessageActions({
        documentId,
        documentTitle,
    });

    const getConversationText = () => {
        return messages
            .map(
                (m) => `**User:** ${m.question} \n\n **Assistant:** ${m.response} `
            )
            .join("\n\n---\n\n");
    };

    const handleBulkAction = (action: (text: string) => void) => {
        const text = getConversationText();
        if (text) {
            action(text);
        }
    };

    if (!messages || messages.length === 0) {
        return null;
    }

    return (
        <TooltipProvider>
            <div className={cn("flex flex-col gap-2", className)}>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            variant="ghost"
                            size="icon"
                            className="h-7 w-7 rounded-full bg-neutral-700 text-neutral-200 hover:bg-neutral-600"
                            onClick={() => handleBulkAction(handleCreateDocumentFromMessage)}
                        >
                            <FaRegFilePdf className="size-[14px]" />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent side="left">Create document from conversation</TooltipContent>
                </Tooltip>

                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            variant="ghost"
                            size="icon"
                            className="h-7 w-7 rounded-full bg-neutral-700 text-neutral-200 hover:bg-neutral-600"
                            onClick={() => handleBulkAction(handleCopyMessage)}
                        >
                            <FaRegCopy className="size-[14px]" />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent side="left">Copy conversation</TooltipContent>
                </Tooltip>

                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            variant="ghost"
                            size="icon"
                            className="h-7 w-7 rounded-full bg-neutral-700 text-neutral-200 hover:bg-neutral-600"
                            onClick={() => handleBulkAction(handleInsertMessageToDocument)}
                        >
                            <BsArrowReturnLeft className="size-[14px]" />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent side="left">Insert conversation</TooltipContent>
                </Tooltip>
            </div>
        </TooltipProvider>
    );
};

export default DiscussBulkActions;
